module.exports = __webpack_public_path__ + "img/vlog.ad000e4a.svg";